import { getAnchorId, getComponentMargin } from '@/utils/builderUtils';
import BirthstoneCarousel from '@/components/BirthstoneCarousel/BirthstoneCarousel';

const birthstoneCarouselImage = src => [
  {
    src,
    size: { width: 30, aspectRatio: 1 },
    breakpoint: 320,
  },
];

export default function BirthstoneCarouselBuilder({ optionalHeader, items, anchorLinkID, margin }) {
  const formattedItems = items
    ? items.map(item => ({
        anchor: item.anchor,
        month: item.month,
        name: item.name,
        imageSrcs: birthstoneCarouselImage(item.img),
        altText: item.altText,
      }))
    : [];

  return (
    <div {...getAnchorId(anchorLinkID)}>
      <BirthstoneCarousel
        optionalHeader={optionalHeader}
        items={formattedItems}
        className={getComponentMargin(margin)}
      />
    </div>
  );
}
